import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { LangContext } from "../../context/LangContext";
import { VscFilePdf } from "react-icons/vsc";
import Bread from "../../common/Bread";
import "./downloads.scss";
import Loader from "../../common/Loader";

const Downloads = () => {
  const lang = React.useContext(LangContext);
  const np = lang.state.np;
  const MianData = React.useState([]);
  const MianDataCat = React.useState([]);
  const breadcrumList = {
    image: "",
    link: "",
    title: "Downloads",
    l1: "Home",
    l2: "Downloads",
    l3: "",
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["downloadsData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/downloads`)
        .then((res) => res.data),
  });
  if (np) {
    MianDataCat.current = data?.downloads_category?.np;
  } else {
    MianDataCat.current = data?.downloads_category?.en;
  }

  if (isFetching) return <Loader />;

  if (isLoading) return <Loader />;

  if (error) return "An error has occurred: " + error.message;

  return (
    <Bread data={breadcrumList}>
      <div className="downloadsPageMainContainer">
        <Tabs className="downloadsPageTabContainer" defaultIndex={1}>
          <TabList className="downloadsPageTabsButtonContainer">
            {MianDataCat?.current?.map((value, index) => (
              <Tab key={index} className="downloadsPageTabButton">
                {value.title}
              </Tab>
            ))}
          </TabList>

          {MianDataCat?.current?.map((item, index) => (
            <TabPanel key={index}>
              <div className="downloadsPageResultContainer">
                {item.downloads.length > 0 ? (
                  item.downloads.map((download, index) => (
                    <a
                      key={index}
                      href={download.DocPath}
                      target="_blank"
                      className="downloadsPageResultItem"
                    >
                      <p className="downloadsPageResultText">
                        {download.title}
                      </p>
                      <VscFilePdf
                        className="icon"
                        color="#3a3a3a"
                        size="25px"
                      />
                    </a>
                  ))
                ) : (
                  <h2>No data</h2>
                )}
              </div>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </Bread>
  );
};

export default Downloads;
